import BoltBanner from "../boltClone/BoltBanner";
import BoltOwnCode from "../boltClone/BoltOwnCode";
import { lazy, Suspense } from "react";

const LyftTeamlogo = lazy(() => import("../LyftClone/LyftTeamlogo"));
const BoltSuperlative = lazy(() => import("../boltClone/BoltSuperlative"));
const BoltNeed = lazy(() => import("../boltClone/BoltNeed"));
const BoltDrive = lazy(() => import("../boltClone/BoltDrive"));
const BoltJourney = lazy(() => import("../boltClone/BoltJourney"));
const BoltBuild = lazy(() => import("../boltClone/BoltBuild"));
const BoltForYou = lazy(() => import("../boltClone/BoltForYou"));
const BoltDevelopement = lazy(() => import("../boltClone/BoltDevelopement"));
const BoltCustom = lazy(() => import("../boltClone/BoltCustom"));
const BoltSmart = lazy(() => import("../boltClone/BoltSmart"));
const BoltWhiteLabel = lazy(() => import("../boltClone/BoltWhiteLabel"));
const BoltGen = lazy(() => import("../boltClone/BoltGen"));
const BoltGlobal = lazy(() => import("../boltClone/BoltGlobal"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));

const bannerData = {
  class: "bolt-banner",
  titlePart1: "Zoom Zoom Clone App",
  titlePart2: "Development Company",
  description: "Canada’s leading experts in scalable, secure, and customizable taxi booking apps built for seamless user experiences.",
  image: "/assets/home/bolt-banner.webp",
  btn1: "contact us",
  btn2: "watch demo",
  counter1: {
    number: "2000+",
    text: "Apps Launched"
  },
  counter2: {
    number: "100+",
    text: "Expert Developers"
  },
  counter3: {
    number: "250+",
    text: "Happy Clients"
  },
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "Zoom Zoom Clone App",
        slug: ""
      },
    ]
  }
};

const OwnCodeData = {
  box1: {
    image: "/assets/home/bolt-own-code-1.webp",
    title: "Own the Entire Source Code",
  },
  box2: {
    image: "/assets/home/bolt-own-code-2.webp",
    title: "Outstanding UI & Superior UX",
  },
  box3: {
    image: "/assets/home/bolt-own-code-3.webp",
    title: "Fully Customized Solution",
  },
  box4: {
    image: "/assets/home/bolt-own-code-4.webp",
    title: "Next-Level Features",
  },
}

const superlativeData = {
  titlePart1: "Why",
  titlePart2: "Zoom Zoom Clone App",
  titlePart3: "Is Ultimate Solution for Taxi Businesses in Canada?",
  description1: "In Canada’s growing urban centres—where harsh winters, sprawling suburbs, and multicultural communities demand efficiency and reliability—the Zoom Zoom Clone App by Mobility Infotech rises as a modern-day mobility essential. Specially crafted for the Canadian market, our ride-hailing app mirrors the simplicity and performance of leading platforms like Zoom Zoom, while offering unmatched customization and scalability. Whether you're a startup in Toronto, a fleet operator in Vancouver, or expanding your taxi business across Alberta or Quebec, our Zoom Zoom Clone delivers an end-to-end solution that combines cutting-edge technology with a smooth user experience. Features like real-time ride-matching, GPS driver tracking, fare estimation, secure in-app payments, and live ride status updates ensure passengers and drivers stay connected and informed, no matter the weather or location.",
  description2: "What sets our clone app apart isn’t just its smart UX or robust backend—it’s the competitive edge it gives your business. From geo-fencing to support local regulations, surge pricing during peak times, bilingual/multilingual interfaces (English, French, and beyond), promo campaigns for customer retention, and full white-label branding, this platform is engineered to thrive in Canada’s diverse transportation landscape. Scalability is at the heart of our system, so as your operations grow from local to national, the app evolves with you, keeping your business agile and future-ready.",
}

const needData = {
  titlePart1: "Taxi",
  titlePart2: "App Development Solutions",
  titlePart3: "for Every Business Need",
  description: "Powering Canada’s transportation evolution—one ride at a time.",
  boxes: [
    {
      image: "/assets/home/bolt-need-1.webp",
      title: "On-Demand Taxi Booking Apps",
      para: "Launch real-time ride-hailing services with instant ride-matching, GPS tracking, and secure payment gateways. Perfect for startups or regional operators looking to bring Zoom Zoom-like convenience to cities across Canada, from Toronto to Calgary.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-2.webp",
      title: "Ride-sharing or Carpooling Apps",
      para: "Promote eco-friendly and wallet-conscious commuting with advanced ride-sharing tech. Our solution enables smart rider-driver matching, fare splitting, and optimized routes—ideal for busy Canadian cities and climate-conscious travellers.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-3.webp",
      title: "Corporate Taxi Booking Apps",
      para: "Simplify employee travel with enterprise-grade taxi solutions. Features like invoicing, ride history, admin dashboards, and policy-based controls make this ideal for Canadian corporations, HR teams, and business mobility managers.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-4.webp",
      title: "Rental or Hourly Taxi Booking Apps",
      para: "Let users book vehicles by the hour or for custom intercity travel. A perfect fit for tourists, professionals, and event-goers seeking flexibility in cities like Vancouver, Ottawa, or Montreal.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-5.webp",
      title: "Luxury & Limousine Booking Apps",
      para: "Serve Canada’s elite with premium vehicle booking options, chauffeur tracking, and high-touch service features. Ideal for hospitality, corporate events, and VIP travel services.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-6.webp",
      title: "Bike Taxi Booking Apps",
      para: "Provide fast, low-cost rides with bike taxi integration—especially valuable for high-traffic areas and last-mile connections in metro centres like Toronto and Montreal.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-7.webp",
      title: "White-Label Taxi Booking Apps",
      para: "Build and launch your own branded taxi service with our fully white-label solutions. Add your logo, colours, features, and language preferences (including French), ensuring a unique identity in any Canadian province.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-8.webp",
      title: "Airport Transfer Taxi Apps",
      para: "Streamline airport transport with real-time flight tracking, pre-scheduling, and automated driver updates. Ideal for fleets operating near major airports like Pearson, YVR, or Calgary International.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-9.webp",
      title: "Electric Vehicle (EV) Taxi Apps",
      para: "Support Canada’s green future with EV-friendly features such as charging station locators, battery status updates, and carbon offset tracking. Designed to align with national goals for sustainable transportation.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-10.webp",
      title: "Paratransit or Accessible Taxi Apps",
      para: "Ensure inclusivity with accessible vehicle options, trained driver integration, and ADA/Canadian accessibility-compliant features. Perfect for community transport services, senior care, and mobility-focused initiatives.",
      btn: "Request a free demo",
    },
  ],
}

const driveData = {
  titlePart1: "Drive Your Success with Canada’s ",
  titlePart2: "Leading Taxi App Development Experts",
  description: "Embrace innovation with our next-gen taxi app solutions and watch your business accelerate like never before.",
  image: "/assets/home/bolt-drive.webp",
  vector: "/assets/home/bolt-drive-vec.webp",
  boxes: [
    {
      image: "/assets/home/drive-circle-1.webp",
      title: "60% Rise in Ride Bookings Per Quarter",
    },
    {
      image: "/assets/home/drive-circle-2.webp",
      title: "45% Reduction in Average Pickup Times",
    },
    {
      image: "/assets/home/drive-circle-3.webp",
      title: "35% Lower Operational Costs Across the Board",
    },
    {
      image: "/assets/home/drive-circle-4.webp",
      title: "44% Boost in Overall Revenue Generation",
    },
    {
      image: "/assets/home/drive-circle-5.webp",
      title: "75% Increase in Customer Loyalty and Repeat Usage",
    },
    {
      image: "/assets/home/drive-circle-6.webp",
      title: "58% Growth in Positive Customer Feedback Each Quarter",
    },
  ],
}

const journeyData = {
  titlePart1: "Our Taxi App Development Journey That",
  titlePart2: "Leads To Your Success",
  description: "Planning to launch a Zoom Zoom like app? Understanding the operational flow is essential. Here's a streamlined look at how our Zoom Zoom Clone App ensures seamless service and user satisfaction:",
  image: "/assets/home/bolt-journey.webp",
  vector: "/assets/home/bolt-journey-vec.webp",
}

const buildData = {
  titlePart1: "We Build Taxi Booking Apps",
  titlePart2: "Using Advanced Features",
  description: "At Mobility Infotech, we integrate the latest technologies into your Zoom Zoom Clone app to deliver exceptional user experience, enhanced security, and efficient fleet management. Here’s a look at the key innovations we bring to Canadian roads:",
  btn: "more features",
  tabs: [{
    title: "AI-Powered Route Optimization",
    description: "Artificial intelligence finds the quickest, least congested routes in real time—saving fuel and time. Perfect for navigating busy urban centres like Toronto, Montreal, and Vancouver.",
    icon: "/assets/home/bolt-build-icon-1.webp",
    image: "/assets/home/bolt-build-1.webp",
  },
  {
    title: "IoT for Vehicle Tracking",
    description: "Our IoT-enabled features provide real-time vehicle tracking, maintenance alerts, and safety monitoring. Operators and passengers gain transparency and peace of mind through detailed trip analytics and driver behavior insights.",
    icon: "/assets/home/bolt-build-icon-2.webp",
    image: "/assets/home/bolt-build-2.webp",
  },
  {
    title: "Chatbots for Customer Support",
    description: "24/7 AI-powered chatbots handle bookings, cancellations, queries, and feedback instantly—reducing your need for manual support and enhancing customer satisfaction across Canada’s diverse user base.",
    icon: "/assets/home/bolt-build-icon-3.webp",
    image: "/assets/home/bolt-build-3.webp",
  },
  {
    title: "Blockchain for Secure Payments",
    description: "Blockchain integration ensures tamper-proof, transparent payment processing. This builds trust with users and drivers by minimizing fraud risk and guaranteeing fair settlements.",
    icon: "/assets/home/bolt-build-icon-4.webp",
    image: "/assets/home/bolt-build-4.webp",
  },
  {
    title: "Intelligent Driver Matching System",
    description: "Our smart algorithm matches passengers with the best available drivers based on proximity, driver ratings, and ride history—cutting wait times and improving service quality.",
    icon: "/assets/home/bolt-build-icon-5.webp",
    image: "/assets/home/bolt-build-5.webp",
  },
  {
    title: "AR for Enhanced Navigation",
    description: "Augmented Reality assists drivers with real-time directions, street recognition, and landmark cues—especially useful in complex Canadian urban environments and unfamiliar routes.",
    icon: "/assets/home/bolt-build-icon-6.webp",
    image: "/assets/home/bolt-build-6.webp",
  },],
}

const forYouData = {
  newClass: "bolt-for-you",
  text: "Mobility Infotech Will",
  text2: "Build a White-Label Taxi Booking",
  title: "App Just for You",
  btn: "BEGIN NOW!",
}

const developementData = {
  titlePart1: "Key Features of Our",
  titlePart2: "Zoom Zoom Clone Taxi App",
  titlePart3: "Development",
  description: "Partner with Mobility Infotech to create a robust, scalable, and future-ready Zoom Zoom-like taxi app tailored for the Canadian market. From ride-hailing to real-time tracking and payments, our feature-rich app supports your growth and operational efficiency every step of the way.",
  btn: "Get Started",
  customer: {
    image: "/assets/home/bolt-developement-1.webp",
    title: "Customer App",
    description: "Your customers enjoy a seamless experience with an intuitive interface and essential ride features, all powered by modern tech that enhances convenience, safety, and trust.",
    boxes: [
      {
        title: "Seamless Ride Booking",
        desc: "Effortless ride requests with a user-friendly interface designed for Canadian users—quick, intuitive, and reliable, whether in Toronto, Vancouver, or Montreal."
      },
      {
        title: "Multiple Payment Options",
        desc: "Accept payments via credit/debit cards, Apple Pay, Google Pay, Interac e-Transfer, or cash—flexible and secure for a better checkout experience."
      },
      {
        title: "Ride Sharing Availability",
        desc: "Customers can share live trip details with friends or family for added safety and transparency during the ride.."
      },
      {
        title: "Schedule a Ride",
        desc: "Allow users to book rides in advance—ideal for airport transfers or early morning commutes in cities like Calgary or Ottawa."
      },
      {
        title: "Live Driver Tracking",
        desc: "Real-time location tracking lets riders monitor their driver’s approach and estimated arrival time on the map."
      },
      {
        title: "Push Notifications",
        desc: "Instant alerts on ride status, driver info, estimated arrival, vehicle details, and promotional offers keep users informed."
      },
    ]
  },
  driver: {
    image: "/assets/home/bolt-developement-2.webp",
    title: "Driver App",
    description: "Our driver-focused Zoom Zoom clone app empowers your drivers to manage rides efficiently while ensuring smooth, profitable journeys.",
    boxes: [
      {
        title: "Direct Calling",
        desc: "Drivers can call passengers directly from the app for pickup coordination or clarifications."
      },
      {
        title: "Optimized Route Navigation",
        desc: "Smart navigation with live traffic updates and route optimization using street view and real-time conditions across Canadian cities."
      },
      {
        title: "Start & End Ride Tracking",
        desc: "Drivers manage ride status with one tap and follow map directions for accurate pickups and drop-offs."
      },
      {
        title: "Built-In Help & Support",
        desc: "Access help for routes, payments, and app usage—all within the app."
      },
      {
        title: "Earnings Dashboard",
        desc: "Drivers view detailed daily earnings summaries and reports right in the app."
      },
      {
        title: "In-App Chat",
        desc: " Secure messaging between drivers and passengers enables smooth coordination without third-party apps."
      },
    ]
  },
  dispatcher: {
    image: "/assets/home/bolt-developement-3.webp",
    title: "Dispatcher Dashboard",
    description: "Our centralized and intelligent dispatcher console lets you monitor and manage every trip, vehicle, and driver in real time.",
    boxes: [
      {
        title: "Automatic Dispatching",
        desc: "Automatically assign the nearest available driver to each booking with minimal delay."
      },
      {
        title: "Booking Management",
        desc: "Track, manage, and dispatch ride requests with real-time fleet control and visibility."
      },
      {
        title: "Live Fleet Tracking",
        desc: "Monitor every vehicle live on a dynamic map—perfect for managing busy urban networks."
      },
      {
        title: "Push Alerts for Dispatch",
        desc: "Send updates, assignments, or emergency alerts to individual drivers or the entire fleet instantly."
      },
      {
        title: "Complete Transaction History",
        desc: "Access records of completed, pending, and cancelled rides, including fares and ride durations."
      },
      {
        title: "Smart Route Planning",
        desc: "Advanced route optimization reduces fuel costs and helps drivers reach passengers faster."
      },
    ]
  },
  admin: {
    image: "/assets/home/bolt-developement-4.webp",
    title: "Admin Panel",
    description: "Gain full control of your Zoom Zoom clone app with a powerful admin panel to oversee operations, analytics, and business performance.",
    boxes: [
      {
        title: "Driver Supervision",
        desc: "Assign or remove drivers based on live demand and service areas with a few clicks."
      },
      {
        title: "In-Depth Analytics",
        desc: "Dashboards show ride volume, revenue, customer behaviour, and driver performance."
      },
      {
        title: "Integrated Payment Management",
        desc: "Process payments securely and review balances via linked Canadian payment gateways."
      },
      {
        title: "Promo & Loyalty Management",
        desc: "Create and manage promo codes, discounts, and loyalty programs directly from the panel."
      },
      {
        title: "Real-Time Admin Chat",
        desc: "Chat instantly with drivers or dispatchers to resolve issues or share instructions."
      },
      {
        title: "Booking Oversight",
        desc: "Monitor, approve, or edit all ride bookings and dispatches via the real-time dashboard."
      },
    ]
  },
}

const customData = {
  titlePart1: "Serving Diverse Industries",
  titlePart2: "with Custom Taxi App Solutions",
  description: "Whether you're a taxi fleet owner, a travel operator, or a large corporation, we provide scalable, feature-rich taxi booking apps to enhance customer experiences and streamline operations.",
  slides: [
    {
      image: "/assets/home/bolt-custom-slide-1.webp",
      title: "Corporate Transportation Providers",
      desc: "Manage corporate mobility efficiently with admin dashboards, daily commute tracking, and smart billing solutions for professional fleets.",
    },
    {
      image: "/assets/home/bolt-custom-slide-2.webp",
      title: "Taxi App for fleet Businesses",
      desc: "Simplify fleet operations with driver assignment, customer bookings, and real-time tracking for smoother daily management.",
    },
    {
      image: "/assets/home/bolt-custom-slide-3.webp",
      title: "Events Transportation Providers",
      desc: "Manage transportation for weddings, conferences, and concerts with real-time updates, easy coordination, and seamless rider experiences every step.",
    },
    {
      image: "/assets/home/bolt-custom-slide-4.webp",
      title: "School And College Operation",
      desc: "Create a safe, reliable student transport system with live tracking, smart route optimization, and parent communication tools.",
    },
    {
      image: "/assets/home/bolt-custom-slide-5.webp",
      title: "Tour & Travel Operation",
      desc: "Enhance travel services with automated bookings, GPS tracking, and itinerary coordination to delight your customers every mile.",
    },
  ]
}

const smartData = {
  titlePart1: "Where",
  titlePart2: "Smart Mobility Meets",
  titlePart3: "Profitable App Business Models",
  description: "A taxi app’s revenue streams go beyond completing rides. Here’s how our Zoom Zoom Clone App can deliver high ROI for your Canadian business:",
  boxes: [
    {
      image: "/assets/home/bolt-smart-1.webp",
      title: "Trip Commissions",
      desc: "Earn commission on every ride booked through your app.",
    },
    {
      image: "/assets/home/bolt-smart-2.webp",
      title: "Surge Pricing",
      desc: "Increase profits with dynamic pricing during peak hours and special events.",
    },
    {
      image: "/assets/home/bolt-smart-3.webp",
      title: "Premium Bookings",
      desc: "Generate extra income with luxury vehicle and SUV bookings.",
    },
    {
      image: "/assets/home/bolt-smart-4.webp",
      title: "Cancellation Fees",
      desc: "Set fees to recover costs from cancelled rides.",
    },
    {
      image: "/assets/home/bolt-smart-5.webp",
      title: "Leasing to Drivers",
      desc: "Enable drivers to join your platform, earn commissions per ride, or lease vehicles via the app.",
    },
    {
      image: "/assets/home/bolt-smart-6.webp",
      title: "Brand Advertising",
      desc: "Monetize by offering advertising space on your app to local or national brands.",
    },
  ]
}

const WhiteLabelData = {
  title: "Develop Your White-Label Taxi Dispatch App with Mobility Infotech",
  description: "With over a decade of experience and the latest tech, Mobility Infotech helps you launch a fully customized Zoom Zoom Clone App tailored to Canada’s diverse market.",
  boxes: [
    {
      image: "/assets/home/bolt-white-1.webp",
      title: "White-Label Solution",
      desc: "Stand out with advanced features and branding customized to your business.",
    },
    {
      image: "/assets/home/bolt-white-2.webp",
      title: "Ready To Use",
      desc: "Get your app live in under 3 days and start scaling your taxi booking revenue.",
    },
    {
      image: "/assets/home/bolt-white-3.webp",
      title: "Highly Scalable",
      desc: "Our solution grows with your business—from local cities to nationwide coverage.",
    },
    {
      image: "/assets/home/bolt-white-4.webp",
      title: "Seamless Integration",
      desc: "Easily connect with your existing Canadian payment gateways, third-party services, and operations systems.",
    },
    {
      image: "/assets/home/bolt-white-5.webp",
      title: "Fully Customizable",
      desc: "Adapt every feature and design element to your brand identity and business needs.",
    },
    {
      image: "/assets/home/bolt-white-6.webp",
      title: "User-Friendly Interface",
      desc: "Designed for intuitive use, offering a seamless experience to both drivers and passengers.",
    },
  ]
}

const genData = {
  titlePart1: "Next-Gen",
  titlePart2: "Taxi App Development",
  titlePart3: "Company Driving Innovation",
  description: "Partner with Mobility Infotech to build your ideal Zoom Zoom Clone App and reach your business goals with these features:",
  boxes: [
    {
      image: "/assets/home/lyft-minimum-1.webp",
      title: "Automate dispatch from the admin panel.",
    },
    {
      image: "/assets/home/lyft-minimum-2.webp",
      title: "Track drivers in real time with GPS.",
    },
    {
      image: "/assets/home/lyft-minimum-3.webp",
      title: "Monitor operations anytime with live dashboards.",
    },
    {
      image: "/assets/home/lyft-minimum-4.webp",
      title: "Access detailed reports and analytics to optimize service.",
    },
    {
      image: "/assets/home/lyft-minimum-5.webp",
      title: "Offer multiple secure payment options.",
    },
    {
      image: "/assets/home/lyft-minimum-6.webp",
      title: "Enable customers to rate trips and provide instant feedback.",
    },
  ],
}

const globalData = {
  titlePart1: "Impact That",
  titlePart2: "Our Taxi App Development ",
  titlePart3: "Company Has Created Globally!",
  counter1: {
    number: "70",
    text: "Increase in Potential ROI",
  },
  counter2: {
    number: "64",
    text: "Increase in Customer Satisfaction",
  },
  counter3: {
    number: "40",
    text: "Increase in Bookings",
  },
  counter4: {
    number: "20",
    text: "Reduction in Maintenance Cost",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What is the Zoom Zoom Clone App by Mobility Infotech?",
    answer: "The Zoom Zoom Clone App is a white-label ride-hailing solution developed by Mobility Infotech. It replicates and enhances features from top apps like Zoom Zoom, offering a tailored experience for Canadian users with real-time tracking, secure payments, and intelligent dispatching.",
  },
  {
    id: "1",
    question: "02. Is this app ready for the Canadian market?",
    answer: "Yes. The app is specifically built for the Canadian landscape with features like multi-language support (English & French), compliance with PIPEDA regulations, and integrations with Canadian payment systems like Interac, credit/debit cards, Apple Pay, and Google Pay.",
  },
  {
    id: "2",
    question: "03. How quickly can we launch the Zoom Zoom Clone App?",
    answer: "With our plug-and-play framework, your branded Zoom Zoom Clone App can be launched in as little as 3 days, depending on your level of customization and integration needs.",
  },
  {
    id: "3",
    question: "04. Can I customize the design and features of the app?",
    answer: "Absolutely. Our Zoom Zoom Clone is a fully white-label and customizable solution. You can tailor everything from the UI/UX to features, branding, payment preferences, and more.",
  },
  {
    id: "4",
    question: "05. What features are included in the Customer App?",
    answer: "Key features include seamless ride booking, live driver tracking, ride scheduling, multiple payment options, real-time notifications, and the ability to share trip details for safety and transparency.",
  },
  {
    id: "5",
    question: "06. What tools are available for drivers in the Driver App?",
    answer: "The Driver App includes direct calling, in-app chat, earnings dashboard, route optimization, real-time navigation, and support features to manage rides and income with ease.",
  },
  {
    id: "6",
    question: "07. How does the Admin Panel support my business growth?",
    answer: "The Admin Panel offers advanced features like driver supervision, in-depth analytics, real-time chat, promo and loyalty management, integrated payment tracking, and complete ride oversight to help you scale smartly.",
  },
  {
    id: "7",
    question: "08. What revenue models does the Zoom Zoom Clone App support?",
    answer: "You can monetize through trip commissions, surge pricing, cancellation fees, premium bookings, in-app advertising, and even leasing vehicles to drivers—maximizing ROI.",
  },
];

export default function ZoomZoom() {
  return (
    <>
      <BoltBanner data={bannerData} />
      <BoltOwnCode data={OwnCodeData} />

      <Suspense fallback={null}>
        <LyftTeamlogo heading={true} newClass="bolt-clone-team" />
        <BoltSuperlative data={superlativeData} />
        <BoltNeed data={needData} />
        <BoltDrive data={driveData} />
        <BoltJourney data={journeyData} />
        <BoltBuild data={buildData} />
        <BoltForYou data={forYouData} />
        <BoltDevelopement data={developementData} />
        <BoltCustom data={customData} />
        <BoltSmart data={smartData} />
        <BoltWhiteLabel data={WhiteLabelData} />
        <BoltGen data={genData} />
        <BoltGlobal data={globalData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
